export default function OpportunityEventLine({ eventName }) {
    const normalized = String(eventName ?? "").trim();
    if (!normalized) return null;

    return (
        <p className="mb-0 text-xs leading-relaxed text-slate-500 md:text-sm">
            <i className="bi bi-calendar-event me-1.5 text-slate-400" aria-hidden />
            {normalized}
        </p>
    );
}
